// Helper function to check if status is "aprovada"
export const isApprovedStatus = (status) => {
  if (!status) return false;
  const lowerStatus = status.toLowerCase().trim();
  return lowerStatus.startsWith('aprovada') || 
         lowerStatus === 'sancionada pelo presidente lula' || 
         lowerStatus === 'sancionada pelo presidente jair bolsonaro';
}; 